import React from 'react';
import SelectedItemsControls from '@Containers/ResultToolbar/SelectedItemsControls';
import { useHistory } from 'react-router-dom';
import { ButtonWithIcon } from '@els/els-react--button';
import { LinkElement } from '@els/els-react--link-element';
import Auth from '@Services/Auth';
import PropTypes from 'prop-types';
import { FEATURES } from '@Constants/rx-ui/constants';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';

function RsProjectTableToolBar({ onDeleteClick, selectedCount, onSelectAllClick, isAllSelected, onImport }) {
  const history = useHistory();
  const importEnabled = Auth.isFeatureEnabled(FEATURES.enableProjectImport);
  return (
    <RsTableToolbar>
      <div className="rs-table-toolbar__left-controls">
        <SelectedItemsControls
          checkAllItems={() => onSelectAllClick()}
          allItemsSelected={!!isAllSelected}
          currentSelectedItems={selectedCount}
          someItemsSelected={selectedCount > 0 && !isAllSelected}
        />
        <ButtonWithIcon
          layout="vertical"
          sprite="Trash"
          type="borderless"
          data-e2e="e2e-rs-toolbar-button-delete"
          size="small"
          className="e2e-rs-toolbar-button-delete"
          disabled={selectedCount <= 0}
          onClick={onDeleteClick}>
          Delete
        </ButtonWithIcon>
      </div>
      <div className="rs-table-toolbar__center-controls">
        <LinkElement
          href="#"
          iconSprite="DrawStructureNew"
          onClick={(e) => {
            e.preventDefault();
            history.push(RsRoute.DRAW_STRUCTURE);
          }}
          data-e2e="e2e-rs-projects-table-draw-structure"
          className="rs-table-toolbar__center-controls--draw-structure e2e-rs-projects-table-draw-structure"
          aria-label="Draw quick search structure">
          Draw Structure
        </LinkElement>
      </div>
      <div className="rs-table-toolbar__right-controls">
        {importEnabled && (
          <ButtonWithIcon
            data-e2e="e2e-rs-projects-table-import"
            sprite="Download"
            iconRight
            type="link"
            size="small"
            className="e2e-rs-projects-table-import"
            onClick={onImport}>
            Import
          </ButtonWithIcon>
        )}
      </div>
    </RsTableToolbar>
  );
}
export default RsProjectTableToolBar;

RsProjectTableToolBar.propTypes = {
  selectedCount: PropTypes.number,
  isAllSelected: PropTypes.bool,
  onSelectAllClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onImport: PropTypes.func,
};
